import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes/routes";
import { PartyModel } from "../../types";
import { defaultImgs } from "../../utils/defaultImages";
import { getUserAvatar } from "../../utils/getMedia";
import getPartyClubDisplayInfo from "../../utils/getPartyClubDisplayInfo";
import { DateFormat, formatDate } from "../../utils/datePareser";
import _ from "./myParty.module.scss";
import handleImgError from "../../handleImgError";
import { PartiesContext } from "../../GlobalContext/partiesContext";

const MyParty = (props: { party: PartyModel }) => {

  const navigate = useNavigate();
  const myParty = props.party;
  const { setSelectedPartyContextData } = useContext(PartiesContext);

  const clubDisplayInfo = useMemo(() => getPartyClubDisplayInfo(myParty), [myParty]);

  const partyDate = useMemo(() => {
    const date = new Date(myParty?.party?.partyDate);
    return formatDate(date, false, DateFormat.Long);
  }, [myParty.party.partyDate]);

  const goToMyPartyPage = (partyId: string) => {
    setSelectedPartyContextData(myParty);
    navigate(routes.MyPartyWithId(partyId));
  };

  const groupAdmin = myParty.invitations.find(inv => inv.isGroupAdmin === true);
  const adminId = groupAdmin ? groupAdmin.id : "";

  return (
    <div className={_.wrapper} >
      <div className={_.userInfoContainer}>
        <img
          className={_.userimage}
          src={getUserAvatar(adminId)}
          alt={"Avatar"}
          onError={(event) => { handleImgError(event, adminId) }}
        />
        <p className={_.userName}>
          {groupAdmin?.firstName} {groupAdmin?.lastName}
        </p>
      </div>

      <div className={_.clubInfoContainer} onClick={() => goToMyPartyPage(myParty.party.id)}>
        <div className={_.dateBox}>
          <p className={_.date}>{partyDate}</p>
        </div>

        <div className={_.clubeImgBox}>
          <img
            className={_.clubImage}
            src={clubDisplayInfo.imageSrc}
            alt={clubDisplayInfo.clubName}
            onError={(e) => {
              const img = e.target as HTMLImageElement;
              if (!img.dataset.fallback) {
                img.dataset.fallback = "1";
                img.src = defaultImgs.ClubImg;
              }
            }}
          />
          
          <p className={_.clubName}>{clubDisplayInfo.clubName}</p>
        </div>
      </div>
    </div>
  );
};

export default MyParty;
